import { h, render, hydrate } from 'preact';
import { useEffect } from 'preact/hooks';
import './styles/main.scss';
import { UrbanSalesPage } from './pages/UrbanSales';
function SearchIndex() {
    useEffect(() => {
        const el = document.getElementById('search-app');
        if (el) {
            el.classList.remove('plp-placeholder-height');
            el.style.height = 'auto';
        }
    }, []);
    return h(UrbanSalesPage, null);
}
const mountElement = document.getElementById('search-app');
if (mountElement) {
    if (mountElement.hasChildNodes()) {
        hydrate(h(SearchIndex, null), mountElement);
    }
    else {
        render(h(SearchIndex, null), mountElement);
    }
}
